export const ellevestMarketingSite = 'https://ellevest.com'
export const defaultPrivateWealthEmail = 'pwmsupport@ellevest.com'



// WEBPACK FOOTER //
// ./src/utils/links.js